goog.provide('el8.ptdata.reports');


goog.require('el8.ptdata.model.report');
goog.require('el8.model.base');


el8.ptdata.reports = (function() {

    var that = new el8_EntitySet({
        model: el8.ptdata.model.report
    });

    that.allByType = function(type) {
        return that.all().filter(function(r) {
            return r.getReportType().toLowerCase() === type.toLowerCase();
        });
    };

    return that;

})();

